import {
  DialogContent,
  Dialog,
} from "@material-ui/core";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import cogoToast from "cogo-toast";
import CustomButton from "../../../../components/CustomButton";
import CustomInput from "../../../../components/CustomInput";
import CustomTextArea from "../../../../components/CustomTextArea";
import { addPayment } from "../../../../redux/actions/payment";
import { addStripePayment } from "../../../../redux/actions/stripePaymentAction";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { getCurrencyFromCountry } from "../../../../utils/constants";
import { makeStyles } from "@material-ui/core/styles";
import { trackFundWalletClick, trackJaraPayPaymentClick } from "../../../../utils/analytics";


const AddFunds = ({ handleChangeStripe, amountStripe, type, selectedCurrency }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [openDialog, setOpenDialog] = useState(false);
  const [openStripe, setOpenStripe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingJara, setLoadingJara] = useState(false);
  const [stripeOrPaystackOption, setStripeOrPaystackOption] = useState(false);
  const stripe = useStripe();
  const elements = useElements();

  const { userData } = useSelector((state) => state.auth);

  const [transfers, setTransfers] = useState({
    email: userData?.email,
    amount: 0,
    description: "",
  });

  const handleCloseModalStripe = () => setOpenStripe(false);
  const handleOpenModalStripe = () => setOpenStripe(true);
  const handleCloseModal = () => setOpenDialog(false);
  const handleOpen = () => setOpenDialog(true);

  const handleChanges = (e) => {
    const { name, value } = e.target;
    setTransfers((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      cogoToast.error("Stripe.js has not loaded yet.");
      return;
    }

    setLoading(true);
    trackFundWalletClick("stripe");

    try {
      const { error: submitError } = await elements?.submit();
      if (submitError) {
        cogoToast.error(submitError.message);
        return;
      }

      const amountInCents = Math.round(Number(amountStripe) * 100);
      const userCurrency = selectedCurrency?.toLowerCase() || "usd";
      const payload = {
        user_id: Number(userData?.id),
        amount: amountInCents,
        currency: userCurrency,
      };

      const action = await addStripePayment(dispatch, payload);
      const clientSecret = action.payload;

      const { error } = await stripe?.confirmPayment({
        elements,
        clientSecret,
        confirmParams: {
          return_url: `${window.location.origin}/payment-success`,
        },
      });

      if (error) {
        cogoToast.error(`Payment failed: ${error.message}`);
      } else {
        cogoToast.success("Payment successful!");
      }
    } catch (error) {
      cogoToast.error(`Unexpected error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleTransfer = async (e) => {
    e.preventDefault();
    if (!transfers.amount || !transfers.description) {
      cogoToast.error("All fields are required");
      return;
    }
    if (transfers.amount < 1000) {
      cogoToast.error("Amount must be greater than or equal to 1000");
      return;
    }

    setLoadingJara(true);
    trackFundWalletClick("jara_pay");
    trackJaraPayPaymentClick(null, Number(transfers.amount), { action: "proceed_checkout" });

    const payload = {
      email: userData?.email,
      amount: Number(transfers.amount),
      description: transfers.description,
    };

    try {
      const action = await addPayment(dispatch, payload);
      if (action?.payload?.valid) {
        cogoToast.success(action.payload.message);
        const checkoutLink = action.payload.entity?.checkoutLink;
        if (checkoutLink) {
          window.open(checkoutLink, "_blank");
        } else {
          cogoToast.error("Checkout link is not available");
        }
      }
    } catch (error) {
      cogoToast.error("Error processing payment: " + error.message);
    } finally {
      setLoadingJara(false);
    }
  };

  return (
    <div className={classes.root}>
      <h3 className={classes.pageTitle}>Add Funds</h3>
      <p className={classes.pageSubtitle}>Choose a payment method to top up your wallet</p>

      {/* Payment option cards */}
      <div className={classes.optionGrid}>

        {/* Stripe option */}
        {type === "stripe" && (
          <div className={classes.optionCard}>
            <div className={classes.optionLeft}>
              <div className={classes.optionIconWrap} style={{ background: "#fff" }}>
                  <img
                  src="/stripelogo.png"
                  alt="stripe"
                  style={{ width: "50px", height: "50px", objectFit: "contain" }}
                />
              </div>
              <div className={classes.optionInfo}>
                <div className={classes.optionTitle}>Stripe</div>
                <div className={classes.optionDesc}>Pay with card · USD wallet</div>
              </div>
            </div>
            {!stripeOrPaystackOption && (
              <div className={classes.optionBtn}>
                <CustomButton
                  backgroundColor="#3A6ED4"
                  color="#fff"
                  text="Pay Now"
                  handleClick={handleOpenModalStripe}
                />
              </div>
            )}
          </div>
        )}

        {/* Jara Pay option */}
        {type === "jaraepay" && (
          <div className={classes.optionCard}>
            <div className={classes.optionLeft}>
              <div className={classes.optionIconWrap} style={{ background: "#ffff", overflow: "hidden" }}>
                <img
                  src="/jarapay.png"
                  alt="Jara Pay"
                  style={{ width: "50px", height: "50px", objectFit: "contain" }}
                />
              </div>
              <div className={classes.optionInfo}>
                <div className={classes.optionTitle}>Jara Pay</div>
                <div className={classes.optionDesc}>Pay with NGN wallet</div>
              </div>
            </div>
            <div className={classes.optionBtn}>
              <CustomButton
                backgroundColor="#3A6ED4"
                color="#fff"
                text="Pay Now"
                handleClick={() => {
                  trackJaraPayPaymentClick(null, null, { action: "select_jarapay_option" });
                  handleOpen();
                }}
              />
            </div>
          </div>
        )}

      </div>

      {/* Jara Pay Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseModal}
        aria-labelledby="jara-dialog-title"
        PaperProps={{
          style: {
            width: "400px",
            borderRadius: "12px",
            padding: "8px",
          },
        }}
      >
        <DialogContent>
          <div style={{ marginBottom: "16px" }}>
            <div style={{ fontSize: "16px", fontWeight: 600, color: "#032250" }}>
              Jara Pay
            </div>
            <div style={{ fontSize: "13px", color: "#7F91A7", marginTop: "4px" }}>
              Enter the amount you want to add
            </div>
          </div>
          <form className="pb-3" onSubmit={handleTransfer}>
            <CustomInput
              type="text"
              label="Amount (NGN)"
              id="amount"
              name="amount"
              value={transfers.amount}
              onChange={handleChanges}
              placeholder="e.g. 5000"
            />
            <CustomTextArea
              id="description"
              name="description"
              type="text"
              label="Description"
              value={transfers.description}
              onChange={handleChanges}
              placeholder="What is this payment for?"
            />
            <CustomButton
              backgroundColor="#3A6ED4"
              color="#fff"
              type="submit"
              text="Proceed to Checkout"
              additionalClass="mt-4 mb-2"
              loading={loadingJara}
            />
          </form>
        </DialogContent>
      </Dialog>

      {/* Stripe Dialog */}
      <Dialog
        open={openStripe}
        onClose={handleCloseModalStripe}
        aria-labelledby="stripe-dialog-title"
        PaperProps={{
          style: {
            width: "400px",
            borderRadius: "12px",
            padding: "8px",
          },
        }}
      >
        <DialogContent
          style={{
            padding: "16px",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            overflow: "auto",
            maxHeight: "80vh",
          }}
        >
          <div style={{ marginBottom: "4px" }}>
            <div style={{ fontSize: "16px", fontWeight: 600, color: "#032250" }}>
              Pay with Stripe
            </div>
            <div style={{ fontSize: "13px", color: "#7F91A7", marginTop: "4px" }}>
              Secure card payment via Stripe
            </div>
          </div>
          <form
            onSubmit={handleSubmit}
            style={{ display: "flex", flexDirection: "column", gap: "12px" }}
          >
            <CustomInput
              type="text"
              label="Amount (USD)"
              id="amount"
              name="amount"
              placeholder="e.g. 50"
              value={amountStripe}
              onChange={handleChangeStripe}
            />
            <div style={{ width: "100%", marginBottom: "4px" }}>
              <PaymentElement />
            </div>
            <CustomButton
              backgroundColor="#3A6ED4"
              color="#fff"
              type="submit"
              text="Pay Now"
              additionalClass="mt-2"
              loading={loading}
            />
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

const useStyles = makeStyles({
  root: {
    padding: "28px 24px",
  },
  pageTitle: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#032250",
    marginBottom: "4px",
  },
  pageSubtitle: {
    fontSize: "13px",
    color: "#7F91A7",
    marginBottom: "24px",
  },
  optionGrid: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  optionCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "14px",
    background: "#FFFFFF",
    border: "1px solid #EFEFEF",
    borderRadius: "12px",
    padding: "16px 18px",
    boxShadow: "0px 1px 4px rgba(0,0,0,0.06)",
    transition: "box-shadow 0.2s",
    "&:hover": {
      boxShadow: "0px 4px 12px rgba(0,0,0,0.09)",
    },
  },
  optionLeft: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    flex: 1,
  },
  optionBtn: {
    flexShrink: 0,
    minWidth: "120px",
  },
  optionIconWrap: {
    width: "44px",
    height: "44px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  optionInfo: {
    flex: 1,
  },
  optionTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#032250",
  },
  optionDesc: {
    fontSize: "12px",
    color: "#7F91A7",
    marginTop: "2px",
    whiteSpace: "nowrap",
  },
});

export default AddFunds;